module.exports = __webpack_public_path__ + "exo-latin-200italic.3a8391359886bc872041.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-200italic.woff2
// module id = ../../../../typeface-exo/files/exo-latin-200italic.woff2
// module chunks = styles